<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10 16.7233C10.1889 16.7233 10.3767 16.6733 10.5489 16.5744C11.2633 16.1622 12.4733 15.6333 14.0389 15.6356C15.0378 15.6367 15.8911 15.8544 16.5611 16.1189C17.2811 16.4022 18.0544 15.8522 18.0544 15.0778V4.98555C18.0544 4.59222 17.8533 4.23 17.5144 4.03C16.8067 3.61222 15.5967 3.07111 14.0256 3.07111C11.9256 3.07111 10.4722 4.04 9.99889 4.38444M10 16.7233C9.81111 16.7233 9.62333 16.6732 9.45111 16.5743C8.73667 16.1621 7.52667 15.6332 5.96111 15.6354C4.96222 15.6366 4.10889 15.8543 3.43889 16.1188C2.71889 16.4021 1.94556 15.8554 1.94556 15.0821C1.94556 12.201 1.94556 6.77988 1.94556 4.98211C1.94556 4.58877 2.14667 4.23099 2.48556 4.03099C3.19333 3.61322 4.40333 3.07211 5.97445 3.07211C8.07445 3.07211 9.52778 4.04099 10.0011 4.38544V16.7232L10 16.7233Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
